export default __webpack_public_path__ + "static/media/product-image-hover-22.5f715190.jpg";